import { Footer } from 'rsuite';
import styled from 'styled-components';

export const FooterStyled = styled(Footer)`
  min-height: 140px;
`;
